import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Robot } from "@phosphor-icons/react";

// "Play AI instead" is hidden for now (Jack, 2026-10-08). Set to true to bring it back.
const SHOW_PLAY_AI_INSTEAD = false;

export default function MatchmakingOverlay({ open, onCancel, onSwitchToAI, waited = 0, mode, opponent = "human" }) {
  const isAI = opponent === "ai";

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md bg-surface border-border p-10 [&>button]:hidden"
        data-testid="matchmaking-overlay"
      >
        <DialogTitle className="sr-only">Matchmaking</DialogTitle>
        <DialogDescription className="sr-only">
          Searching for an opponent matched by Elo rating
        </DialogDescription>
        <div className="flex flex-col items-center text-center">
          <div className="relative w-28 h-28 mb-6">
            <span className="absolute inset-0 rounded-full bg-brand/30 animate-pulse-ring" />
            <span className="absolute inset-3 rounded-full bg-brand/40 animate-pulse-ring [animation-delay:.5s]" />
            <div className="absolute inset-6 rounded-full bg-brand text-brand-foreground flex items-center justify-center tile-stamp text-2xl">
              J
            </div>
          </div>
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-muted-foreground">
            {mode === "turn_based" ? "Turn-based" : "Real-time"} · {isAI ? "AI bot" : "Human queue"}
          </p>
          <h3 className="font-display text-3xl font-black mt-2 tracking-tight">
            {isAI ? "Spinning up your bot" : "Finding opponent"}
          </h3>
          <p className="text-muted-foreground mt-2 text-sm">
            {isAI ? "Almost there…" : `Searching by closest Elo · ${waited}s`}
          </p>

          {!isAI && (
            <p className="text-xs text-muted-foreground/70 mt-4 max-w-xs">
              We'll keep waiting until a real opponent at your Elo is available.{SHOW_PLAY_AI_INSTEAD && " Don't want to wait? Play the AI instead."}
            </p>
          )}

          <div className="flex flex-col items-stretch gap-2 mt-6 w-full max-w-[260px]">
            {!isAI && SHOW_PLAY_AI_INSTEAD && (
              <Button
                onClick={onSwitchToAI}
                className="rounded-full bg-brand hover:bg-brand-hover text-brand-foreground"
                data-testid="matchmaking-switch-ai-btn"
              >
                <Robot size={16} weight="fill" className="mr-1.5" /> Play AI instead
              </Button>
            )}
            <Button
              variant="ghost"
              onClick={onCancel}
              className="rounded-full text-muted-foreground hover:text-foreground"
              data-testid="matchmaking-cancel-btn"
            >
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
